import React from 'react';
import { Form } from '@ant-design/compatible';
import BrandDetailInfoStatus from '../BrandDetailInfoStatus';
import BrandDetailInfoSeller from '../BrandDetailInfoSeller';
import BrandDetailInfo from '../BrandDetailInfo';
import BrandDetailInfoBusiness from '../BrandDetailInfoBusiness';
import BrandDetailInfoBalance from '../BrandDetailInfoBalance';
import BrandDetailInfoSns from '../BrandDetailInfoSns';
import BrandDetailInfoHeader from '../BrandDetailInfoHeader/BrandDetailInfoHeader';
import { useBrandDetailInfo } from '../../../../../hooks/brand/detail/useBrandDetailInfo';
import './BrandDetailInfoSection.scss';

const BrandDetailInfoSection = (props) => {
  const { storeId, form, setData } = props;
  const {
    permitRegistrationStoreTag,
    rejectRegistrationStoreTag,
    permitBrand,
    onSubmitEditDetailInfo,
    brandDetailInfo,
    storeTagGroupList,
    edit,
    onCancelEdit,
    isEditable,
  } = useBrandDetailInfo(storeId, form);

  const { statusInfo, sellerInfo, brandInfo, businessInfo, balanceInfo, snsInfoRows } = brandDetailInfo;
  const { status } = statusInfo;

  return (
    <div className="brand-detail-info-section">
      <BrandDetailInfoHeader
        storeId={storeId}
        status={status}
        isEditable={isEditable}
        setData={setData}
        permitBrand={permitBrand}
        onSubmit={onSubmitEditDetailInfo}
        cancelEdit={onCancelEdit}
        edit={edit}
      />

      <div className="status-seller-info-section">
        {/* 판매점 입점상태 */}
        <BrandDetailInfoStatus form={form} setData={setData} isEditable={isEditable} data={statusInfo} />

        {/* 브랜드 담당자 정보 */}
        <BrandDetailInfoSeller
          form={form}
          setData={setData}
          storeId={storeId}
          isEditable={isEditable}
          data={sellerInfo}
        />
      </div>

      {/* 브랜드 정보 */}
      <BrandDetailInfo
        form={form}
        setData={setData}
        isEditable={isEditable}
        storeId={storeId}
        status={status}
        data={brandInfo}
        storeTagGroupList={storeTagGroupList}
        permitRegistrationStoreTag={permitRegistrationStoreTag}
        rejectRegistrationStoreTag={rejectRegistrationStoreTag}
      />

      {/*사업자 정보*/}
      <BrandDetailInfoBusiness form={form} setData={setData} isEditable={isEditable} data={businessInfo} />

      {/*정산 정보*/}
      <BrandDetailInfoBalance form={form} setData={setData} isEditable={isEditable} data={balanceInfo} />

      {/* sns 정보 */}
      <BrandDetailInfoSns form={form} setData={setData} isEditable={isEditable} data={snsInfoRows} />
    </div>
  );
};

export default Form.create()(BrandDetailInfoSection);
